import { Link } from 'react-router-dom';
import { Hammer, ArrowLeft } from 'lucide-react';

export default function EmDesenvolvimentoPage() {
    return (
        <main className="min-h-screen bg-black flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center">
                <div className="mb-8 flex justify-center">
                    <div className="p-6 bg-orange-500/10 rounded-full border border-orange-500/20">
                        <Hammer size={48} className="text-orange-500" />
                    </div>
                </div>
                <h1 className="text-4xl font-black text-white italic uppercase mb-4">Em Desenvolvimento</h1>
                <p className="text-white/40 font-bold uppercase tracking-widest text-sm mb-10">Estamos trabalhando duro para trazer essa funcionalidade o mais rápido possível.</p>
                <Link to="/" className="inline-flex items-center gap-2 px-8 py-4 bg-orange-600 hover:bg-orange-500 text-white font-black rounded-xl transition-all uppercase italic shadow-lg shadow-orange-900/20"><ArrowLeft size={18} /> Voltar para o início</Link>
            </div>
        </main>
    );
}
